import { render, staticRenderFns } from "./DialogGreetingsPromotions.vue?vue&type=template&id=0524df4e"
import script from "./DialogGreetingsPromotions.vue?vue&type=script&lang=js"
export * from "./DialogGreetingsPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports